import {
	FETCH_ORDER_BEGIN,
	FETCH_ORDER_SUCCESS,
	FETCH_ORDER_FAILURE,
	ADD_CARD_BEGIN,
	ADD_CARD_SUCCESS,
	ADD_CARD_FAILURE,
	REMOVE_CARD_BEGIN,
	REMOVE_CARD_SUCCESS,
	REMOVE_CARD_FAILURE,
	ADD_MEDIA_BEGIN,
	ADD_MEDIA_SUCCESS,
	ADD_MEDIA_FAILURE,
	REMOVE_ORDER_MEDIA_BEGIN,
	REMOVE_ORDER_MEDIA_SUCCESS,
	REMOVE_ORDER_MEDIA_FAILURE,
	ADD_ALL_DIGITAL_BEGIN,
	ADD_ALL_DIGITAL_SUCCESS,
	ADD_ALL_DIGITAL_FAILURE,
	REMOVE_ALL_DIGITAL_BEGIN,
	REMOVE_ALL_DIGITAL_SUCCESS,
	REMOVE_ALL_DIGITAL_FAILURE,
	ADD_PRODUCT_BEGIN,
	ADD_PRODUCT_SUCCESS,
	ADD_PRODUCT_FAILURE,
	REMOVE_PRODUCT_BEGIN,
	REMOVE_PRODUCT_SUCCESS,
	REMOVE_PRODUCT_FAILURE,
	ADD_COUPON_BEGIN,
	ADD_COUPON_SUCCESS,
	ADD_COUPON_FAILURE,
	CLEAR_COUPON_ERROR,
	SAVE_ORDER_CUSTOMER_BEGIN,
	SAVE_ORDER_CUSTOMER_SUCCESS,
	SAVE_ORDER_CUSTOMER_FAILURE,
	FINISH_BEGIN,
	FINISH_SUCCESS,
	FINISH_FAILURE,
	CHANGE_SELECTED_MEDIA_ORDER_SUCCESS,
	CLEAR_ORDER
} from '../actions';

const initialState = {
	selectedMediaId: null,
	order: {},
	loading: false,
	error: '',
	isAddingAllDigital: false,
	mediaBeingAdded: [],
	mediaBeingRemoved: [],
	productsBeingUpdated: [],
	couponLoading: false,
	couponError: '',
};

export default function orderReducer(state = initialState, action) {
	switch (action.type) {
	case FETCH_ORDER_BEGIN:
	case ADD_CARD_BEGIN:
	case REMOVE_CARD_BEGIN:
	case SAVE_ORDER_CUSTOMER_BEGIN:
	case FINISH_BEGIN:
		return {
			...state,
			loading: true,
			error: '',
		};

	case ADD_MEDIA_BEGIN:
		return {
			...state,
			loading: true,
			error: '',
			mediaBeingAdded: [...state.mediaBeingAdded, action.payload.mediaId],
		};

	case REMOVE_ORDER_MEDIA_BEGIN:
		return {
			...state,
			loading: true,
			error: '',
			mediaBeingRemoved: [...state.mediaBeingRemoved, action.payload.mediaId],
		};

	case REMOVE_ALL_DIGITAL_BEGIN:
	case ADD_ALL_DIGITAL_BEGIN:
		return {
			...state,
			loading: true,
			error: '',
			isAddingAllDigital: true,
		};

	case ADD_PRODUCT_BEGIN:
	case REMOVE_PRODUCT_BEGIN:
		return {
			...state,
			loading: true,
			error: '',
			productsBeingUpdated: [...state.productsBeingUpdated, action.payload.productId],
		};

	// Coupons track their own flags so applying one does not swap the
	// checkout step for the full-area loader driven by `loading`.
	case ADD_COUPON_BEGIN:
		return {
			...state,
			couponLoading: true,
			couponError: '',
		};

	case ADD_COUPON_SUCCESS:
		return {
			...state,
			couponLoading: false,
			couponError: '',
			order: action.payload.order,
		};

	case ADD_COUPON_FAILURE:
		return {
			...state,
			couponLoading: false,
			couponError: action.payload.error,
		};

	case CLEAR_COUPON_ERROR:
		return {
			...state,
			couponError: '',
		};

	case FETCH_ORDER_SUCCESS:
	case ADD_CARD_SUCCESS:
	case REMOVE_CARD_SUCCESS:
	case ADD_ALL_DIGITAL_SUCCESS:
	case REMOVE_ALL_DIGITAL_SUCCESS:
	case SAVE_ORDER_CUSTOMER_SUCCESS:
	case FINISH_SUCCESS:
		return {
			...state,
			loading: false,
			order: action.payload.order,
			isAddingAllDigital: false,
		};

	case ADD_PRODUCT_SUCCESS:
	case REMOVE_PRODUCT_SUCCESS:
		return {
			...state,
			loading: false,
			order: action.payload.order,
			isAddingAllDigital: false,
			productsBeingUpdated: state.productsBeingUpdated.filter(
				(productId) => productId !== action.payload.productId
			),
		};

	case ADD_MEDIA_SUCCESS:
		return {
			...state,
			loading: false,
			order: action.payload.order,
			isAddingAllDigital: false,
			mediaBeingAdded: state.mediaBeingAdded.filter(mediaId => mediaId !== action.payload.mediaId),
		};

	case REMOVE_ORDER_MEDIA_SUCCESS:
		return {
			...state,
			loading: false,
			order: action.payload.order,
			selectedMediaId: null,
			mediaBeingRemoved: state.mediaBeingRemoved.filter(mediaId => mediaId !== action.payload.mediaId),
		};

	case FETCH_ORDER_FAILURE:
	case ADD_CARD_FAILURE:
	case REMOVE_CARD_FAILURE:
	case ADD_ALL_DIGITAL_FAILURE:
	case REMOVE_ALL_DIGITAL_FAILURE:
	case SAVE_ORDER_CUSTOMER_FAILURE:
	case FINISH_FAILURE:
		return {
			...state,
			loading: false,
			error: action.payload.error,
			isAddingAllDigital: false,
		};

	case ADD_PRODUCT_FAILURE:
	case REMOVE_PRODUCT_FAILURE:
		return {
			...state,
			loading: false,
			error: action.payload.error,
			isAddingAllDigital: false,
			productsBeingUpdated: state.productsBeingUpdated.filter(
				(productId) => productId !== action.payload.productId
			),
		};

	case ADD_MEDIA_FAILURE:
		return {
			...state,
			loading: false,
			error: action.payload.error,
			isAddingAllDigital: false,
			mediaBeingAdded: state.mediaBeingAdded.filter(mediaId => mediaId !== action.payload.mediaId),
		};

	case REMOVE_ORDER_MEDIA_FAILURE:
		return {
			...state,
			loading: false,
			error: action.payload.error,
			isAddingAllDigital: false,
			mediaBeingRemoved: state.mediaBeingRemoved.filter(mediaId => mediaId !== action.payload.mediaId)
		};

	case CHANGE_SELECTED_MEDIA_ORDER_SUCCESS:
		return {
			...state,
			selectedMediaId: action.payload
		}

	case CLEAR_ORDER:
		return {...initialState}

	default:
		return state;
	}
}
